export default (theme) => ({
  cardContainer: {
    paddingTop: 5,
    paddingBottom: 5,
    paddingLeft: 5,
    color: "grey",
    margin: "0px 15px",
    border: "1px solid #F3F3F3",
    minHeight: 85
  },
  label: {
    fontWeight: "bold",
  },
});
